import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Row,
  Image,
  Form,
  Modal,
  Radio,
} from "antd";
import { useParams } from "react-router-dom";
import { useStateGlobalContext } from "../../../../../../contexts/GlobalContext";
import { doPatch } from "../../../../../../API/apis";
import Webcam from "react-webcam";
import { Card } from "antd/es";
import Notification from "../../../../../../components/Notification/Notification";
import showConfirmModal from "../../../../../../components/ModalConfirm/ModalConfirm";
import Loader from "../../../../../../components/Loader/Loader";


const fallbackImage =
  "data:image/png;base64,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";

const Pictures = () => {
  const { id } = useParams();
  const [form] = Form.useForm()
  const [visible, setVisible] = useState(false);
  const [selectedPicture, setSelectedPicture] = useState(null);
  const [capturedImage, setCapturedImage] = useState(null);
  const { patientBasicInfo, getPatientData , loading} = useStateGlobalContext();
  const webcamRef = React.useRef(null);

  const handlePictures = () => {
    setVisible(true);
  };

  const handleClose = () => {
    setVisible(false);
    setSelectedPicture(null);
    setCapturedImage(null);

    if (webcamRef.current) {
      const videoTrack = webcamRef.current.video.srcObject.getVideoTracks()[0];
      videoTrack.stop();
    }
    form.resetFields()
  };

  const handlePictureChange = (value) => {
    setSelectedPicture(value);
  };

  const handleCaptureImage = () => {
    const imageSrc = webcamRef.current.getScreenshot();
    setCapturedImage(imageSrc);
  };

  const handleSave = async () => {
    if (!capturedImage) return Notification.error("Please Capture the Image");
    const data = { [selectedPicture]: capturedImage };
    try {
      const response = await doPatch(`/patient/update-info/${id}/`, data);
      if (response.status === 200) {
        Notification.success("Picture Updated Successfully");
        getPatientData(id);
        handleClose();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleDelete = (pictureType) => {
    showConfirmModal({
      title: "Confirm Delete?",
      icon: null,
      content: "Are you sure you want to delete this?",
      okText: "Delete",
      okType: "danger",
      cancelText: "Cancel",
      className: "custom-modal",
      onOk() {
        deleteImage(pictureType);
      },
    });
  };

  const deleteImage = async (pictureType) => {
    try {
      const data = { [pictureType]: "" };
      const response = await doPatch(`/patient/update-info/${id}/`, data);
      if (response.status === 200) {
        Notification.success("Image Deleted Successfully");
        getPatientData(id);
      }
    } catch (error) {
      Notification.error("Something Went Wrong");
    }
  };

  useEffect(() => {
    getPatientData(id);
  }, [id]);

if(loading){
  return <Loader/>
}

  return (
    <div className="wrapper shadow-class">
      <div className="flex justify-between">
        <h1 className="text-[1.125rem] font-bold mb-4">Profile and ID Pictures</h1>
        <Button onClick={handlePictures}>Change Pictures</Button>
      </div>
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} md={10} lg={8}>
          <Card>
            <h3 className="text-center">Patient Profile Picture</h3>
            {patientBasicInfo && patientBasicInfo?.profile_picture ? (
              <div>
              <Image
                src={patientBasicInfo?.profile_picture}
                fallback={fallbackImage}
                preview={patientBasicInfo?.profile_picture ? true : false}
              />
              <Button type="primary" className="danger__button w-full mt-2" onClick={() => handleDelete("profile_picture")}>Delete</Button>
              </div>
            ) : (
              <p className="text-center">No Image Added </p>
            )}
          </Card>
        </Col>
        <Col xs={24} sm={12} md={10} lg={8}>
          <Card>
            <h3 className="text-center">ID Card Picture</h3>
            <div>
              {patientBasicInfo && patientBasicInfo?.identification_picture ? (
                <div>
                <Image
                  src={patientBasicInfo?.identification_picture}
                  className="text-center"
                  preview={
                    patientBasicInfo?.identification_picture ? true : false
                  }
                />
                <Button type="primary" className="danger__button w-full mt-2" onClick={()=>handleDelete("identification_picture")}>Delete</Button>
                </div>
              ) : (
                <p className="text-center">No Image Added </p>
              )}
            </div>
          </Card>
        </Col>

        <Col xs={24} sm={12} md={10} lg={8}>
          <Card>
            <h3 className="text-center">Insurance Card Picture</h3>
            <div>
              {patientBasicInfo && patientBasicInfo?.insurance_card ? (
                <div>
                <Image
                  src={patientBasicInfo?.insurance_card}
                  className="text-center"
                  preview={patientBasicInfo?.insurance_card ? true : false}
                />
                <Button type="primary" className="danger__button w-full mt-2" onClick={()=>handleDelete("insurance_card")}>Delete</Button>
                </div>
              ) : (
                <p className="text-center">No Image Added </p>
              )}
            </div>
          </Card>
        </Col>
      </Row>

      <Modal
        title="Change Pictures"
        open={visible}
        footer={null}
        onCancel={handleClose}
        maskClosable={false}
        width="700px"
      >
        <Form layout="vertical">
          <Form.Item label="Select Picture" name='select_picture'>
            <Radio.Group
              defaultValue={null}
              buttonStyle="solid"
              size="large"
              onChange={(e) => handlePictureChange(e.target.value)}
            >
              <Radio.Button value="profile_picture">
                Profile Picture
              </Radio.Button>
              <Radio.Button value="identification_picture">
                ID Card Picture
              </Radio.Button>
              <Radio.Button value="insurance_card">
                Insurance Card Picture
              </Radio.Button>
            </Radio.Group>
          </Form.Item>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            {selectedPicture && (
              <div>
                <h4 className="text-center">Webcam</h4>
                <div className="flex justify-center mb-4">
                  <Webcam
                    audio={false}
                    ref={webcamRef}
                    screenshotFormat="image/jpeg"
                    width={300}
                    height={200}
                  />
                </div>
                <div className="flex justify-center">
                  <Button onClick={handleCaptureImage}>Capture Image</Button>
                </div>
              </div>
            )}
            {capturedImage && (
              <div style={{ flex: 1 }}>
                <h4 className="text-center">Captured Image</h4>
                <div className="flex justify-center mb-4">
                  <Image src={capturedImage} width={300} height={200} />
                </div>
              </div>
            )}
          </div>
          <div className="flex justify-end mt-4">
            <Button onClick={handleClose}>Cancel</Button>
            <Button type="primary" onClick={handleSave} className="ml-2">
              Save
            </Button>
          </div>
        </Form>
      </Modal>
    </div>
  );
};

export default Pictures;
